
function AnswerWarning({ setShowAnswerWarning }) {
  
  return (
    <div className="answer-warning-overlay">
      <div className="answer-warning-box">
        <h3>Please answer the question first</h3>
        <p>You must select an option before moving to the next question.</p>
        <button
          onClick={() => setShowAnswerWarning(false)}
          className="close-btn"
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default AnswerWarning